/* eslint-disable no-undef */
import React, { useEffect, useRef, useState } from 'react'
import {
  Box,
  Container,
  Grid,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import { SLASH_HEIGHT } from '../../constants'
import { AnimatedText, Image, Logo, RichText, Slash } from '../../components'
import { useStyles } from './downloadApp.styles'
import AppDownloadLink from '../../components/AppDownloadLink/AppDownloadLink'

const huaweiDevicesRegex = /ALP-|AMN-|ANA-|ANE-|ANG-|AQM-|ARS-|ART-|ATU-|BAC-|BLA-|BRQ-|CAG-|CAM-|CAN-|CAZ-|CDL-|CDY-|CLT-|CRO-|CUN-|DIG-|DRA-|DUA-|DUB-|DVC-|ELE-|ELS-|EML-|EVA-|EVR-|FIG-|FLA-|FRL-|GLK-|HMA-|HW-|HWI-|INE-|JAT-|JEF-|JER-|JKM-|JNY-|JSC-|LDN-|LIO-|LON-|LUA-|LYA-|LYO-|MAR-|MED-|MHA-|MLA-|MRD-|MYA-|NCE-|NEO-|NOH-|NOP-|OCE-|PAR-|PIC-|POT-|PPA-|PRA-|RNE-|SEA-|SLA-|SNE-|SPN-|STK-|TAH-|TAS-|TET-|TRT-|VCE-|VIE-|VKY-|VNS-|VOG-|VTR-|WAS-|WKG-|WLZ-|JAD-MLD-|RTE-|NAM-|NEN-|BAL-|JLN-|YAL|MGA-|FGD-|XYAO-|BON-|ALN-|ALT-|BRA-|DBY2-|STG-|MAO-|LEM-|GOA-|FOA-|MNA-|LNA-/i

const DownloadApp = ({ data, t, location, pageContext, ...rest }) => {
  const { hero, ctaSection } = data
  const { bannerForm, description, heading, bannerImageUrl } = hero
  const url = rest?.bannerImages ? rest?.bannerImages[0]?.bucketUrl : undefined
  const { downloadAppstoreUrl, downloadPlaystoreUrl, downloadAppGalleryUrl } =
    ctaSection || {}

  const styles = useStyles()
  const theme = useTheme()

  const slashHeight = SLASH_HEIGHT
  const newHeight = useMediaQuery(theme.breakpoints.down('sm'))
    ? slashHeight * 0.4
    : slashHeight

  const headingRef = useRef(null)

  const [os, setOs] = useState()

  useEffect(() => {
    const userAgent =
      // eslint-disable-next-line no-undef
      typeof window !== 'undefined' && navigator.userAgent.toLowerCase()
    const userOs = (() => {
      if (!userAgent) return undefined
      if (/iphone/i.test(userAgent)) {
        return 'iOS'
      }
      if (/ipad/i.test(userAgent)) {
        return 'iOS'
      }
      if (/android/i.test(userAgent)) {
        return 'android'
      }
      if (huaweiDevicesRegex.test(navigator.userAgent)) {
        return 'huawei'
      }
      return undefined
    })()
    setOs(userOs)
  }, [])

  useEffect(() => {
    if (os && typeof window !== 'undefined') {
      const redirectionUrl = (() => {
        if (os === 'iOS') return downloadAppstoreUrl
        if (os === 'android') return downloadPlaystoreUrl
        if (os === 'huawei') return downloadAppstoreUrl
        return undefined
      })()

      const redirectionTimer =
        redirectionUrl &&
        setTimeout(() => {
          window.location.replace(redirectionUrl)
        })
      return () => {
        clearTimeout(redirectionTimer)
      }
    }
    return () => {}
  }, [os, downloadAppstoreUrl, downloadPlaystoreUrl])

  return (
    <>
      <Slash height={newHeight} />
      <main className={styles.mainContainer}>
        <Container maxWidth={'xl'}>
          <Grid container className={styles.root} mx="auto" my={0}>
            <Grid
              ref={headingRef}
              item
              xs={12}
              sm={5}
              className={styles.textWrapper}
            >
              <header className={styles.header}>
                <Logo />
              </header>

              <Box className={styles.title}>
                {heading && (
                  <AnimatedText
                    animationType={'slideUp'}
                    variant="h1"
                    content={heading.trim()}
                  />
                )}
              </Box>

              {(description?.raw || bannerForm?.description?.description) && (
                <Box>
                  {description?.raw && (
                    <RichText
                      className={styles.description}
                      variant="body1"
                      document={JSON.parse(description.raw)}
                    />
                  )}
                </Box>
              )}

              {(downloadAppstoreUrl ||
                downloadPlaystoreUrl ||
                downloadAppGalleryUrl) && (
                <Box className={styles.formCta}>
                  {downloadAppstoreUrl && (
                    <AppDownloadLink link={downloadAppstoreUrl} />
                  )}
                  {downloadPlaystoreUrl && (
                    <AppDownloadLink link={downloadPlaystoreUrl} />
                  )}
                  {downloadAppGalleryUrl && (
                    <AppDownloadLink link={downloadAppGalleryUrl} />
                  )}
                </Box>
              )}
            </Grid>

            {bannerImageUrl && (
              <Grid item xs={12} md={5} className={styles.imgWrapper}>
                <Image file={{ url: url || bannerImageUrl }} title={heading} />
              </Grid>
            )}
          </Grid>
        </Container>
      </main>
    </>
  )
}

export default DownloadApp
